export const getMediaUrl = ({ assetType, format, page, startOffset, uid, }) => {
    // We intentionally fetch video and audio directly from Cloudinary because these files have issues playing when served through our CDN
    const baseUrl = format === 'mp4' || format === 'webm' || format === 'aac'
        ? 'https://res.cloudinary.com/contra'
        : 'https://media.contra.com';
    const transforms = format === 'json'
        ? []
        : format === 'aac'
            ? [`q_auto:best`]
            : [`w_800`, `q_auto:best`];
    if (startOffset !== undefined) {
        transforms.push(`so_${startOffset}`);
    }
    if (page) {
        transforms.push(`pg_${page}`);
    }
    const transformsPathPart = transforms.length
        ? `/${transforms.join(',')}/`
        : '/';
    const formatPathPart = assetType === 'raw' ? '' : `.${format}`;
    return `${baseUrl}/${assetType}/upload${transformsPathPart}${uid}${formatPathPart}`;
};
//# sourceMappingURL=getMediaUrl.js.map